import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import { thunk } from "redux-thunk";
import rootReducer from "./reducers"; // Combine all reducers here

// Create the Redux store
const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
